module.exports = __webpack_public_path__ + "Sailec-Regular.4f9fcee336fb10a460bd.woff";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Regular/Sailec-Regular.woff
// module id = ../../../../../src/assets/fonts/Sailec-Regular/Sailec-Regular.woff
// module chunks = styles